module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_nhn629.9195e05e7dbc24ef7e2982f195a3ec6c.png";